import { render, staticRenderFns } from "./DashboardPropertyStats.vue?vue&type=template&id=9bf58af6&scoped=true"
import script from "./DashboardPropertyStats.vue?vue&type=script&lang=js"
export * from "./DashboardPropertyStats.vue?vue&type=script&lang=js"
import style0 from "./DashboardPropertyStats.vue?vue&type=style&index=0&id=9bf58af6&prod&lang=scss&scoped=true"
import style1 from "./DashboardPropertyStats.vue?vue&type=style&index=1&id=9bf58af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf58af6",
  null
  
)

export default component.exports